import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDoubleDown } from "@fortawesome/free-solid-svg-icons";

// CSS
import "./Hero.css";

// Assets
import heroVideo from "../../assets/videos/Homepage Video.mp4";
// import downArrow from "../../assets/images/down-arrow.png";
import posterImg from "../../assets/images/LOADING-SCREEN.jpg";

const Hero = (props) => {
  // const [innerWidth, setInnerWidth] = useState(window.innerWidth);
  const [transform, setTransform] = useState(false);

  // const handleWindowSizeChange = () => {
  //   setInnerWidth(window.innerWidth);
  // };

  useEffect(() => {
    // window.addEventListener("resize", handleWindowSizeChange);
    window.addEventListener("scroll", handleScroll, true);
    return () => {
      // window.removeEventListener("resize", handleWindowSizeChange);
      window.removeEventListener("scroll", handleScroll, true);
    };
  });

  const handleScroll = () => {
    if (window.pageYOffset > 10) {
      setTransform(true);
    } else {
      setTransform(false);
    }
  };

  const renderDesktop = () => {
    return (
      <div className="hero-container" ref={props.refProp}>
        <div className="hero_content_container">
          <video
            autoPlay
            muted
            loop
            playsInline
            poster={posterImg}
            id="hero-video"
          >
            <source src={heroVideo} type="video/mp4" />
            Your browser does not support HTML5 video.
          </video>
          <div className="hero-text-container">
            <p>
            Investing in Mission-Critical Digital Infrastructure Assets
            </p>
          </div>
          <div className="hero-arrow-container">
            <span className={transform ? "hero-arrow-hide" : "hero-arrow-show"}>
              <FontAwesomeIcon icon={faAngleDoubleDown} />
            </span>
          </div>
        </div>
      </div>
    );
  };

  //   const renderMobile = () => {
  //     return (
  //       <div className="hero_container" ref={props.refProp}>
  //         <div className="hero_content_container">
  //           <video
  //             autoPlay
  //             muted
  //             loop
  //             playsInline
  //             poster={posterMobile}
  //             id="hero-video"
  //           >
  //             <source src={heroMobileVideo} type="video/mp4" />
  //             Your browser does not support HTML5 video.
  //           </video>
  //         </div>
  //       </div>
  //     );
  //   };
  return (
    <>
      {/* {innerWidth <= 600 ? renderMobile() : renderDesktop()} */}
      {renderDesktop()}
    </>
  );
};

export default Hero;
